import { CheckoutAuthResponse } from '../../models/checkout/checkout-auth-response.interface';

export const mockCheckoutAuthResponse: CheckoutAuthResponse = {
  externalApiToken: 'mockAccessToken12345',
};
